import { debounce } from 'lodash';
import { useEffect } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
export default (function (enabled, storagePrefix) {
    if (enabled === void 0) { enabled = true; }
    if (storagePrefix === void 0) { storagePrefix = 'scroll-position:'; }
    var path = useRouteMatch().path;
    var action = useHistory().action;
    var location = useLocation();
    var _a = (location.state || {}).restoreScrollPosition, restoreScrollPosition = _a === void 0 ? false : _a;
    useEffect(function () {
        if (enabled) {
            try {
                var item = window.sessionStorage.getItem(storagePrefix + path);
                var scrollPosition = item ? JSON.parse(item) : 0;
                var saveScrollPosition_1 = debounce(function () {
                    try {
                        window.sessionStorage.setItem(storagePrefix + path, JSON.stringify(window.scrollY));
                    }
                    catch (error) {
                        console.error(error.message);
                    }
                }, 500);
                window.scrollTo(0, restoreScrollPosition || action === 'POP' ? scrollPosition : 0);
                window.addEventListener('scroll', saveScrollPosition_1);
                return function () {
                    saveScrollPosition_1.flush();
                    window.removeEventListener('scroll', saveScrollPosition_1);
                };
            }
            catch (error) {
                console.error(error.message);
            }
        }
    }, [action, path, restoreScrollPosition, enabled]);
});
//# sourceMappingURL=useScrollRestoration.js.map